module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_mansole.2b30146ce718c59706ea55981881642f.png";